import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  X,
  Map,
  Tractor,
  Wallet,
  FileCheck,
  CreditCard,
  Plug,
  Sparkles,
  Building2,
  Settings,
  LogOut,
  ChevronRight
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';

const menuItems = [
  { to: '/parcellaire', icon: Map, label: 'Parcellaire', color: '#22c55e' },
  { to: '/eta', icon: Tractor, label: 'ETA Chantiers', color: '#f59e0b' },
  { to: '/finance', icon: Wallet, label: 'Finance', color: '#3b82f6' },
  { to: '/reglementaire', icon: FileCheck, label: 'Réglementaire', color: '#8b5cf6' },
  { to: '/integrations', icon: Plug, label: 'Intégrations', color: '#06b6d4' },
  { to: '/billing', icon: CreditCard, label: 'Tarifs', color: '#ec4899' },
  { to: '/workspace', icon: Building2, label: 'Workspace', color: '#6366f1' },
  { to: '/creator', icon: Sparkles, label: 'Creator', color: '#f97316' },
];

export const MobileMoreMenu = ({ isOpen, onClose }) => {
  const { logout, user } = useAuth();

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] bg-background md:hidden"
      data-testid="mobile-more-menu"
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <h2 className="text-lg font-semibold">Menu</h2>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <X className="w-5 h-5" />
        </Button>
      </div>

      {/* User info */}
      <div className="p-4 border-b bg-muted/30">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="text-lg font-bold text-primary">
              {user?.prenom?.[0]}{user?.nom?.[0]}
            </span>
          </div>
          <div>
            <p className="font-semibold">{user?.prenom} {user?.nom}</p>
            <p className="text-sm text-muted-foreground">{user?.email}</p>
          </div>
        </div>
      </div>

      {/* Menu items */}
      <div className="p-2 space-y-1 overflow-y-auto max-h-[calc(100vh-200px)]">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onClose}
              className={({ isActive }) => cn(
                "flex items-center gap-3 px-4 py-3 rounded-xl transition-colors",
                isActive 
                  ? "bg-primary/10 text-primary" 
                  : "hover:bg-muted"
              )}
            >
              <div 
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${item.color}15` }}
              >
                <Icon className="w-5 h-5" style={{ color: item.color }} />
              </div>
              <span className="flex-1 font-medium">{item.label}</span>
              <ChevronRight className="w-4 h-4 text-muted-foreground" />
            </NavLink>
          );
        })}
      </div>

      {/* Bottom actions */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t bg-background" style={{ paddingBottom: 'calc(16px + env(safe-area-inset-bottom))' }}>
        <div className="flex gap-2">
          <NavLink to="/settings" onClick={onClose} className="flex-1">
            <Button variant="outline" className="w-full">
              <Settings className="w-4 h-4 mr-2" />
              Paramètres
            </Button>
          </NavLink>
          <Button 
            variant="destructive" 
            onClick={() => { logout(); onClose(); }}
            className="flex-1"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Déconnexion
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileMoreMenu;
